module.exports = "/_next/static/images/hardhat-monotone-48c2d0d016fe4fdcc4df9cc83ce91793.svg";